"use strict";
"use client";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApolloNextAppProvider = exports.SuspenseCacheSingleton = exports.ApolloClientSingleton = void 0;
const React = __importStar(require("react"));
const client_1 = require("@apollo/client");
const RehydrationContext_1 = require("./RehydrationContext");
exports.ApolloClientSingleton = Symbol.for("ApolloClientSingleton");
exports.SuspenseCacheSingleton = Symbol.for("ApolloSuspenseCacheSingleton");
const ApolloNextAppProvider = ({ makeClient, children, makeSuspenseCache, }) => {
    var _a, _b;
    const clientRef = React.useRef();
    const suspenseCacheRef = React.useRef();
    if (typeof window !== "undefined") {
        clientRef.current = (_a = window[exports.ApolloClientSingleton]) !== null && _a !== void 0 ? _a : (window[exports.ApolloClientSingleton] = makeClient());
        suspenseCacheRef.current = (_b = window[exports.SuspenseCacheSingleton]) !== null && _b !== void 0 ? _b : (window[exports.SuspenseCacheSingleton] = makeSuspenseCache === null || makeSuspenseCache === void 0 ? void 0 : makeSuspenseCache());
    }
    else {
        if (!clientRef.current) {
            clientRef.current = makeClient();
        }
        if (!suspenseCacheRef.current && makeSuspenseCache) {
            suspenseCacheRef.current = makeSuspenseCache();
        }
    }
    return (React.createElement(client_1.ApolloProvider, { client: clientRef.current, 
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore This is there in the betas and gone in the RC. Will be removed next version.
        suspenseCache: suspenseCacheRef.current },
        React.createElement(RehydrationContext_1.RehydrationContextProvider, null, children)));
};
exports.ApolloNextAppProvider = ApolloNextAppProvider;
//# sourceMappingURL=ApolloNextAppProvider.js.map